import React, { FC, useMemo } from "react";
import cn from "classnames";
import { getTextFromHtml } from "src/utils/getTextFromHtml";
import "./styles.scss";

interface Props {
  children: string;
  className?: string;
  viewType?: "html" | "text";
}
export const TextEditorView: FC<Props> = ({
  children,
  className,
  viewType = "html",
}) => {
  const content = useMemo(() => {
    return viewType === "html" ? children : getTextFromHtml(children);
  }, [viewType, children]);

  return (
    <div
      className={cn("editor", className)}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};
